module.exports = __webpack_public_path__ + "media/images/landings/promotion_3/img_flow-05-aff3ec9dd2ae62e41c1425b6364e28db.png";